import { createReducer } from '@reduxjs/toolkit'
import { catalogActions } from './actions'
import { initialState } from './initialState'

/**
 * Reducer do módulo Catalog
 */
export const catalogReducer = createReducer(initialState, (builder) => {
  builder
    // Fetch batteries
    .addCase(catalogActions.fetchBatteriesRequest, (state, action) => {
      state.listLoading = true
      state.listError = null
      if (action.payload) {
        state.filters = { ...state.filters, ...action.payload }
      }
    })
    .addCase(catalogActions.fetchBatteriesSuccess, (state, action) => {
      state.listLoading = false
      state.batteries = action.payload.batteries
      state.pagination = action.payload.pagination
      if (action.payload.filters) {
        state.filters = { ...state.filters, ...action.payload.filters }
      }
    })
    .addCase(catalogActions.fetchBatteriesFailure, (state, action) => {
      state.listLoading = false
      state.listError = action.payload.error
    })
    
    // Update filters
    .addCase(catalogActions.updateFilters, (state, action) => {
      state.filters = { ...state.filters, ...action.payload, page: 1 }
    })
    
    // Fetch battery
    .addCase(catalogActions.fetchBatteryRequest, (state, action) => {
      state.batteryLoading = true
      state.batteryError = null
      state.currentBatteryId = action.payload.id || action.payload.slug || null
    })
    .addCase(catalogActions.fetchBatterySuccess, (state, action) => {
      state.batteryLoading = false
      state.batteryCache[action.payload.key] = action.payload.battery
      state.currentBatteryId = action.payload.battery.id
    })
    .addCase(catalogActions.fetchBatteryFailure, (state, action) => {
      state.batteryLoading = false
      state.batteryError = action.payload.error
    })
    
    // Fetch featured batteries
    .addCase(catalogActions.fetchFeaturedBatteriesRequest, (state) => {
      state.featuredLoading = true
      state.featuredError = null
    })
    .addCase(catalogActions.fetchFeaturedBatteriesSuccess, (state, action) => {
      state.featuredLoading = false
      state.featuredBatteries = action.payload.batteries
    })
    .addCase(catalogActions.fetchFeaturedBatteriesFailure, (state, action) => {
      state.featuredLoading = false
      state.featuredError = action.payload.error
    })
    
    // Search batteries
    .addCase(catalogActions.searchBatteriesRequest, (state) => {
      state.searchLoading = true
      state.searchError = null
    })
    .addCase(catalogActions.searchBatteriesSuccess, (state, action) => {
      state.searchLoading = false
      state.searchResults = action.payload.batteries
      state.searchSuggestions = action.payload.suggestions
    })
    .addCase(catalogActions.searchBatteriesFailure, (state, action) => {
      state.searchLoading = false
      state.searchError = action.payload.error
    })
    
    // Clear battery cache
    .addCase(catalogActions.clearBatteryCache, (state) => {
      state.batteryCache = {}
      state.currentBatteryId = null
    })
    
    // Clear errors
    .addCase(catalogActions.clearListError, (state) => {
      state.listError = null
    })
    .addCase(catalogActions.clearBatteryError, (state) => {
      state.batteryError = null
    })
})

